import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { CHART_STRINGS } from '../helpers/graphConstants';

const TreatmentInitiationLabel = ({ viewBox }) => {
  const { x, y } = viewBox;
  if (x === undefined || y === undefined) {
    return null;
  }

  const endX = x;
  const endY = y;
  const arrowEndX = endX + 10;
  const arrowEndY = endY - 5;
  const startX = endX + 60;
  const startY = endY - 30;
  const textX = startX + 10;
  const textY = startY;

  const arrowHeadSize = 8;
  const angle = Math.atan2(endY - startY, endX - startX);
  const p1x = arrowEndX - arrowHeadSize * Math.cos(angle - Math.PI / 6);
  const p1y = arrowEndY - arrowHeadSize * Math.sin(angle - Math.PI / 6);
  const p2x = arrowEndX - arrowHeadSize * Math.cos(angle + Math.PI / 6);
  const p2y = arrowEndY - arrowHeadSize * Math.sin(angle + Math.PI / 6);
  const arrowPoints = `${arrowEndX},${arrowEndY} ${p1x},${p1y} ${p2x},${p2y}`;

  return (
    <g className="treatment-initiation-label">
      <text x={textX} y={textY}>
        {CHART_STRINGS.FEATURE_NOTE}
      </text>
      <line x1={startX} y1={startY} x2={arrowEndX} y2={arrowEndY} />
      <polygon points={arrowPoints} />
      <circle cx={endX} cy={endY} r={3} />
    </g>
  );
};

TreatmentInitiationLabel.propTypes = {
  viewBox: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
};

export default memo(TreatmentInitiationLabel);
